<sol-topbar [customBreadcrumbs]="showCustomBreadcrumbs$()" [embedded]="isEmbedded$()">
  <ng-container slot="breadcrumbs">
    @if (showPartnerSwitcher$()) {
      <sol-select
        [type]="SolFieldType.transparent"
        placeholder="asm-topbar.choose-partner"
        [value]="partner$()"
        [availableValues]="partners$()"
        [searchable]="true"
        [disabled]="loading$()"
        [grow]="true"
        (value)="onPartnerChange($event)"
      />
      <span class="sol-topbar-divider">/</span>
    }

    @if (showScopeSwitcher$()) {
      <sol-select
        [type]="SolFieldType.transparent"
        placeholder="asm-topbar.choose-scope"
        [value]="scope$()"
        [availableValues]="scopes$()"
        [searchable]="true"
        [disabled]="loading$()"
        [grow]="true"
        (value)="onScopeChange($event)"
      />
      <span class="sol-topbar-divider">/</span>

      @if (subscopes$().length > 1) {
        <sol-select
          [type]="SolFieldType.transparent"
          placeholder="asm-topbar.choose-subscope"
          [value]="subscope$()"
          [availableValues]="subscopes$()"
          [searchable]="true"
          [disabled]="loading$()"
          [grow]="true"
          (value)="onSubscopeChange($event)"
        />
        <span class="sol-topbar-divider">/</span>
      }
    }
  </ng-container>
</sol-topbar>
